import { render, staticRenderFns } from "./create-wastetype.vue?vue&type=template&id=b96ad846&"
import script from "./create-wastetype.vue?vue&type=script&lang=ts&"
export * from "./create-wastetype.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "create-wastetype.vue"
export default component.exports